import { render, staticRenderFns } from "./BaseModalContainer.vue?vue&type=template&id=70d33a17&scoped=true&"
import script from "./BaseModalContainer.vue?vue&type=script&lang=js&"
export * from "./BaseModalContainer.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalContainer.vue?vue&type=style&index=0&id=70d33a17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d33a17",
  null
  
)

export default component.exports